<template>
  <footer>
    <div class="container">
      <div class="footer-top">
        <div class="footer-brand">
          <router-link :to="isEnglish ? '/en' : '/'" class="logo">minder<span>rente</span>.nl</router-link>
          <p>{{ t('footer.tagline') }}</p>
        </div>
        <div class="footer-disclaimer">
          <strong>{{ t('footer.disclaimer.title') }}</strong><br>
          {{ t('footer.disclaimer.text') }}
        </div>
      </div>
      <div class="footer-bottom">
        <div>{{ t('footer.copyright') }}</div>
        <div class="footer-links">
          <router-link :to="isEnglish ? '/en/contact' : '/contact'">{{ t('footer.contact') }}</router-link>
          <router-link :to="isEnglish ? '/en/privacy' : '/privacy'">{{ t('footer.privacy') }}</router-link>
        </div>
      </div>
    </div>
  </footer>
</template>

<script setup>
import { useLocale } from '../composables/useLocale'

const { t, isEnglish } = useLocale()
</script>

<style scoped>
footer {
  background: var(--bg-deep);
  color: var(--bg);
  padding: 80px 0 40px;
}
@media (max-width: 768px) {
  footer { padding: 48px 0 28px; }
}
.footer-top {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 40px;
  margin-bottom: 48px;
}
@media (max-width: 600px) { .footer-top { grid-template-columns: 1fr; } }
.footer-brand .logo {
  color: var(--bg);
  font-family: 'Fraunces', serif;
  font-weight: 800;
  font-size: 32px;
  letter-spacing: -0.03em;
  text-decoration: none;
}
.footer-brand .logo span {
  background: var(--yellow);
  color: var(--ink);
  padding: 0 8px;
  border-radius: 6px;
  transform: rotate(-2deg);
  display: inline-block;
}
.footer-brand p {
  margin-top: 20px;
  color: rgba(255, 255, 255, 0.65);
  font-size: 15px;
  max-width: 36ch;
  line-height: 1.6;
}
.footer-disclaimer {
  background: rgba(255, 255, 255, 0.05);
  border-radius: 16px;
  padding: 24px;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.7);
  line-height: 1.6;
}
.footer-disclaimer strong { color: var(--accent-light); }
.footer-bottom {
  border-top: 1px solid rgba(255, 255, 255, 0.15);
  padding-top: 28px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 16px;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.5);
}
.footer-links {
  display: flex;
  gap: 20px;
}
.footer-bottom a {
  color: rgba(255, 255, 255, 0.7);
  text-decoration: none;
  border-bottom: 1px solid transparent;
}
.footer-bottom a:hover { border-bottom-color: var(--accent-light); }
</style>
